import { CssBaseline, ThemeProvider } from '@mui/material';
import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import Hotjar from '../Hotjar';
import ToastContainer from '../feature/shared/ToastContainer';
import { router } from '../shared/custom-router';
import { theme } from '../shared/theme';
import './App.css';
import { useToastUpdater } from '../feature/shared/Toast';
import { MantineProvider } from '@mantine/core';
import { theme as mantineTheme } from '../shared/mantine.theme';
import OpenInAppPrompt from '../feature/components/AppPrompt/OpenInAppPrompt';
import ReleaseNotesNudge from '../feature/components/Notifications/ReleaseNotesNudge';

function App() {
    useToastUpdater();
    useEffect(() => {
        window.addEventListener('error', (e) => {
            if (e.message.includes('ResizeObserver')) {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div',
                );
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay',
                );

                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        });
    }, []);
    return (
        <MantineProvider withGlobalStyles withNormalizeCSS theme={mantineTheme}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Hotjar />
                <ToastContainer />
                <ReleaseNotesNudge />
                <OpenInAppPrompt />
                <RouterProvider router={router} />
            </ThemeProvider>
        </MantineProvider>
    );
}

export default App;
